import { Navigate, useParams } from '@exam-center/router';

export default function ExamDistributionByMonthPage() {
  const { year: currentYear, month: currentMonth } = useParams(
    '/:examCenterCode/exam-events/years/:year/months/:month',
  );

  return (
    <Navigate
      to='/admin/exam-distribution/year/:year/month/:month/exam-assigning'
      params={{ year: currentYear.toString(), month: currentMonth.toString() }}
      replace
    />
  );
}
